export default __webpack_public_path__ + "dd4fe6634fde7fb946e92c0ee422f367.png";